import React from 'react';
import { withTheme } from 'styled-components'
import { LightContainer, Flex, FlexColumn } from '../../Reusable/Container';
import { Text } from '../../Reusable/Text';
import CountdownTimer from '../../Reusable/CountdownTimer';

const AionExchangeRate = ({ internationalQuoteInfo, updating, getInternationalQuote, width, margin, theme }) => {
    return (
        <LightContainer background="#F3FAFF" borderColor="#F3FAFF" width={width ? width : "100%"} style={{ minWidth: 500, padding: "12px 16px", margin }}>
            <Flex fullWidth between centerH>
                <FlexColumn gap="4px">
                    <Text size="14px" color={theme.colors.secondary}>
                        Aion Exchange Rate
                    </Text>

                    <Flex start bottom gap="4px" style={{ height: 28 }}>
                        <Text weight="600" primary className={`quote-field ${updating ? 'updating' : ''}`} size="20px" margin="0 0 2px">
                            1
                        </Text>
                        <Text bottom primary className={`quote-field ${updating ? 'updating' : ''}`}>
                            USD
                        </Text>
                        <Text weight="600" primary className={`quote-field ${updating ? 'updating' : ''}`} size="20px" margin="0 0 2px">
                            =
                        </Text>
                        <Text weight="600" primary className={`quote-field ${updating ? 'updating' : ''}`} size="20px" margin="0 0 2px">
                            {internationalQuoteInfo?.conversionRate}
                        </Text>
                        <Text bottom primary className={`quote-field ${updating ? 'updating' : ''}`}>
                            {internationalQuoteInfo?.currency?.toUpperCase()}
                        </Text>
                    </Flex>
                </FlexColumn>

                {(internationalQuoteInfo && !updating) && (
                    <CountdownTimer size="24px" rightText onTimerComplete={getInternationalQuote} />
                )}
            </Flex>
        </LightContainer>
    );
};

export default withTheme(AionExchangeRate);
